import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getPDFSimplificada (payload, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getUploadFacturae.data)
    })
  } else {
    const req = {
      url: '/api/emisionfacturas/getpdffacturasimplificada',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      responseType: 'blob',
      params: { envio: false, ...params },
      data: payload,
    }
    const res = await axiosInstance(req)
    return { data: res.data, headers: res.headers }
  }
}

export { getPDFSimplificada }
